import {useState, useEffect, useRef} from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Container, Typography, Button, styled} from '@mui/material';
import {Card, CardContent} from '@mui/material'
import { getAttemptedInterview } from '../../api/axios'
import io from "socket.io-client"
import InterviewAttemptsButton from '../../components/InterviewAttemptsButton';
import InterviewAttemptsInfo from '../../components/InterviewAttemptsInfo'

const BeginButton = styled(Button)(({ theme }) => ({
    border: '1.5px solid #6B3A8F',
    borderRadius: '24px',
    boxShadow: "10px 10px 80px 0px rgba(63, 39, 102, 0.1)", // Converted valid shadow color
    backgroundColor: "#2F272F",
    padding: '10px 40px',
    '&:hover': {
        backgroundColor: '#372D41',
        border: '1.5px solid #6B3A8F',
    },
}));

const InterViewStartPage = () => {
    const [interviewAttempts, setInterviewAttempts] = useState([])
    const [processingInterview, setProcessingInterview] = useState(null)
    const [viewSelectedAttempt, setViewSelectedAttempt] = useState(null)
    const [isProcessing, setIsProcessing] = useState(true)
    const [dataLoaded, setDataLoaded] = useState(false)
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const shouldPoll = searchParams.get("shouldPoll") === "true";

    const startInterview = () => {
        navigate(`/interview-select-role`)
    } 

    useEffect(() => {
        // const socket = io(process.env.REACT_APP_BACKEND_URL)

        let pollingInterval

        const fetchInterviewAttempts = async () => {
            try {
                const response = await getAttemptedInterview()
                console.log(response.data)
                const doneInterviews = response.data.filter(item => item.processingStatus === "done");
                const processing = response.data.filter(item => item.processingStatus === "Processing");
                console.log(processing)
                setInterviewAttempts(doneInterviews)
                setProcessingInterview(processing[0]);
                if (!shouldPoll) {
                    clearInterval(pollingInterval);
                }
                setDataLoaded(true)
            } catch (error) {
                console.error(`Error fetching all courses: ${error}`)
            }

        }

        // socket.on('InterviewEvent', (data) => {
        //     setProcessingInterview(prevInterview => {
        //         if (!prevInterview) {
        //             return data;
        //         }
        //         if (data._id.toString() === prevInterview._id.toString()) {
        //             setIsProcessing(false);
        //             return data;
        //         }
        //         return prevInterview;
        //     });
        // })

        fetchInterviewAttempts()

        pollingInterval = setInterval(fetchInterviewAttempts, 30000)
        
        return () => clearInterval(pollingInterval)
    }, [])

    const handleClick = (selectedAttempt) => {
        setViewSelectedAttempt(selectedAttempt)
    }

    return (
        <Box sx={{
            height: '100%',
            width: '100%',
            paddingLeft: '5%',
            paddingTop: '5%',
            display: 'flex',
            flexDirection: 'column',
            color: '#E1E1E6'
        }}>
            <Box paddingBottom={5} sx={{width: '100%', display: 'flex', 'justifyContent': 'space-between'}}>
                <Typography variant='h4' sx={{width: '80%', textAlign:'start'}}>Virtual Interview</Typography>
                <Box sx={{width: '20%'}}>
                    <BeginButton variant='contained' onClick={startInterview} data-cy='start-interview-button'>
                            <Typography sx={{
                                background: "linear-gradient(90deg, #D9BAFF, #D4E8F8, #DAB6E0)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}>
                                Start New Interview
                            </Typography>
                    </BeginButton>
                </Box>
            </Box>
            <Box sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
            }}>
                {console.log(interviewAttempts)}
                {console.log(processingInterview)}
                {console.log(isProcessing)}
                <Container sx={{width: '100%', height: '80%', display: 'flex', flexDirection: 'column', alignItems:'center', justifyContent: 'start'}}>
                    <Card sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        borderRadius: '24px',
                        overflow: 'hidden',
                        background: 'linear-gradient(144.47deg, #1D151D 42.84%, #4E2D33 179.39%)',
                    }}>
                        <Typography sx={{fontSize: '22px', color: '#E1E1E6', fontWeight: 'bold', padding: '5%'}}>
                            View Interview Attempts
                        </Typography>

                        <Box sx={{
                            width: '95%',
                            minHeight: '75%',
                            maxHeight: '75%',
                            overflow: 'auto',
                            textAlign: 'center',
                        }}> 
                            {interviewAttempts.map((attempt, index) => {
                                return (
                                    <InterviewAttemptsButton key={index} attempt={attempt} onClick={() => handleClick(attempt)}/>
                                )
                            })}
                            {console.log("processingInterview:", processingInterview)}
                            {processingInterview && (<InterviewAttemptsButton attempt={processingInterview} onClick={() => handleClick(processingInterview)} />)}
                        </Box>
                    </Card>

                </Container>
                <Container sx={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems:'center', justifyContent: 'start'}}>
                    {viewSelectedAttempt && <InterviewAttemptsInfo attempt={viewSelectedAttempt}/>}

                </Container>
            </Box>
        </Box>
    )

}

export default InterViewStartPage